export const dealVisitFeedbackMixin = {
  data() {
    return {
      indexes: {
        0: 'fifth',
        1: 'fourth',
        2: 'third',
        3: 'second',
        4: 'first',
      },
    };
  },
  computed: {
    // Return array for choice in visit feedback input range
    sliderChoices() {
      const array = [];
      Object.keys(this.indexes).forEach((choice) => array.push({
        id: +choice,
        title: this.trans(
          `messaging.actions.ask_feedback.slider_choice_${this.indexes[choice]}_title`,
        ),
        text: this.trans(
          `messaging.actions.ask_feedback.slider_choice_${this.indexes[choice]}_content`,
          { company_name: window.COMPANY_NAME },
        ),
      }));
      return array.reverse();
    },
  },
};
